import { render } from "./Exam_Approver.vue?vue&type=template&id=373025d0&scoped=true"
import script from "./Exam_Approver.js?vue&type=script&lang=js"
export * from "./Exam_Approver.js?vue&type=script&lang=js"

import "./Exam_Approver.vue?vue&type=style&index=0&id=373025d0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373025d0"]])

export default __exports__